<template>
  <div class="content">
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.name") }}
          </div>
          <div class="input-group mb-3">
            <input
              v-model="formData['name']"
              type="text"
              class="input-style input-padding"
              maxlength="100"
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.code") }}
          </div>
          <div class="input-group mb-3">
            <input
              v-model="formData['externalId']"
              type="text"
              class="input-style input-padding"
              maxlength="30"
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.keycloak") }}
          </div>
          <div class="input-group mb-3">
            <input
              v-model="formData['keycloak']"
              type="text"
              class="input-style input-padding"
              maxlength="30"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.status") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
              class="input-style"
              :itemsSource="status"
              :selectedValuePath="'id'"
              :displayMemberPath="'label'"
              :isRequired="false"
              v-model="formData['status']"
              disabled
              :style="'color:#bbb'"
            >
            </wj-combo-box>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.timeZone") }}
          </div>
          <div class="input-group mb-3">
            <wj-auto-complete
              class="input-style"
              id="theAutoComplete"
              :itemsSource="timeZones"
              :selectedValuePath="'id'"
              :displayMemberPath="'name'"
              :isRequired="false"
              v-model="formData['timezone']"
              disabled
              :style="'color:#bbb'"
            >
            </wj-auto-complete>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.culture") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
              class="input-style"
              :itemsSource="cultures"
              :selectedValuePath="'code'"
              :displayMemberPath="'description'"
              :isRequired="false"
              v-model="formData['culture']"
              disabled
              :style="'color:#bbb'"
            >
            </wj-combo-box>
          </div>
        </div>
      </div>

      <div class="row">
        
        <div class="col-md-4">
          <div
            class="label"
          >
            {{ $t("pages.Client.forbiddenBusinessActs") }}
          </div>
          <div class="input-group mb-3">
            <wj-multi-select
              :isDisabled="true"
              :headerFormat="`{count:n0} ${$t('pages.Client.forbiddenBusinessActs')}`"
              :itemsSource="businessActs"
              :displayMemberPath="'display'"
              :selectedValuePath="'businessAct'"
              :checkedItems="businessActs.filter((ba) => isSelectedItem(formData, ba))"
              class="input-style"
            ></wj-multi-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.rgpd") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
              class="input-style"
              :itemsSource="rgpd"
              :selectedValuePath="'id'"
              :displayMemberPath="'label'"
              :isRequired="false"
              v-model="formData['gdpr']"
              disabled
              :style="'color:#bbb'"
            >
            </wj-combo-box>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.apiCurve") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
              class="input-style"
              :itemsSource="apiCurves"
              :selectedValuePath="'externalId'"
              :displayMemberPath="'description'"
              :isRequired="false"
              v-model="formData['apiCurve']"
              disabled
              :style="'color:#bbb'"
            >
            </wj-combo-box>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.daysNumber") }}
          </div>
          <div class="input-group mb-3">
            <input
              v-model="formData['daysNumber']"
              type="number"
              class="input-style input-padding"
              min="1"
              disabled
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.levelsNumber") }}
          </div>
          <div class="input-group mb-3">
            <input
              v-model="formData['levelsNumber']"
              type="number"
              class="input-style input-padding input-auto-width"
              min="1"
              max="65165"
              disabled
              style="flex: 1.3"
            />
            <a
              class="dm-a-default"
              :style="formData.levelsNumber > 0 ? '' : notClickable"
              @click.prevent="
                formData.levelsNumber > 0
                  ? (showModal = true)
                  : (showModal = false)
              "
            >
              <i class="scf-Information"></i> {{ $t("pages.Client.viewZones") }}
            </a>
            <formModalZones
              v-if="formData.levels"
              :key="formData.externalId"
              :show="showModal"
              :title="zoneModalTitle"
              :type="'notif'"
              :nbZones="formData['levelsNumber']"
              :initialLevels="formData.levels"
              :fromPage="'details'"
              @update:show="showModal = false"
            >
            </formModalZones>
          </div>
          <div class="label">
            {{ $t("pages.Client.comment") }}
          </div>
          <div class="input-group mb-3">
            <textarea
              v-model="formData['comment']"
              maxlength="400"
              class="textarea-style input-padding"
              disabled
            >
            </textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.assignedServices") }}
          </div>
          <div class="input-group mb-3">
            <wj-list-box
              class="input-style selection-style"
              :itemsSource="checkedServices"
              :displayMemberPath="'description'"
              :isRequired="false"
              :isDisabled="true"
            >
            </wj-list-box>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import ClientService from "../services/ClientService";
import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.vue2.core";
import {
  WjComboBox,
  WjAutoComplete,
  WjListBox,
  WjMultiSelect,
} from "@grapecity/wijmo.vue2.input";
import formModalZones from "../components/FormModalZones.vue";

export default defineComponent({
  name: "DetailsForm",
  inject: ["accessToken"],
  components: {
    WjComboBox,
    WjListBox,
    formModalZones,
    WjAutoComplete,
    WjMultiSelect,
  },
  watch: {
     currentScope(newVal) {
        if (newVal) {
          this.clientService = new ClientService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.clientService = new ClientService(newVal, this.currentScope);
        }
      },
  },
  data() {
    return {
      formData: {
        name: "",
        externalId: "",
        keycloak: "",
        timezone: "",
        culture: "",
        status: "",
        gdpr: "",
        apiCurve: "",
        daysNumber: "",
        levelsNumber: "",
        services: [],
        levels: [],
      },
      clientService: new ClientService(this.$jwt.token, this.$jwt.scope),
      currentScope: this.$jwt.scope,
      culture: computed(() => this.$i18n.locale),
      checkedServices: [],
      zoneModalTitle: computed(() => this.$t("pages.Client.zonesLabels")),
      notClickable: {
        cursor: "default",
        color: "#bbb",
      },
      showModal: false,
    };
  },
  props: {
    timeZones: {
      type: Array,
      required: true,
      default: () => [],
    },
    cultures: {
      type: Array,
      required: true,
      default: () => [],
    },
    status: {
      type: Array,
      required: true,
      default: () => [],
    },
    businessActs: {
      type: Array,
      required: true,
      default: () => [],
    },
    rgpd: {
      type: Array,
      required: true,
      default: () => [],
    },
    apiCurves: {
      type: Array,
      required: true,
      default: () => [],
    },
    availableServices: {
      type: Array,
      required: true,
      default: () => [],
    },
    client: {
      type: Object,
      required: false,
    },
    pageFrom: {
      type: String,
      required: false,
    },
  },
  methods: {
    isSelectedItem(formData, ba) {
      if (!formData || !formData.configuration || !formData.configuration.ForbiddenBusinessActs) return false;
      return ba.businessAct.every(v => formData?.configuration?.ForbiddenBusinessActs?.includes(v));
    },
  },
  mounted() {
    this.formData = this.client;
    this.formData.gdpr = this.client.gdpr.toString();
    this.formData.configuration = JSON.parse(this.client.clientConfiguration);
    var service = null;
    var servicesResult = [];
    for (let index in this.client.services) {
      service = this.clientService.getService(
        this.availableServices,
        this.client.services[index]
      );
      servicesResult.push(service);
    }
    this.checkedServices = servicesResult;
  },
});
</script>

<style scoped lang="scss">
@import "../../node_modules/@grapecity/wijmo.styles/wijmo.css";

input,
textarea {
  color: #bbb !important;
}
</style>
<style scoped src="../assets/css/client.css"></style>
